import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=6706de0e&scoped=true&"
import script from "./classInfo.vue?vue&type=script&lang=ts&"
export * from "./classInfo.vue?vue&type=script&lang=ts&"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=6706de0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706de0e",
  null
  
)

export default component.exports